import React from "react";
import Mockman from "mockman-js";
function MockAPI() {
  return (
    <div className="MockAPI" >
      <Mockman colorScheme="dark" />
    </div>
  );
}

export default MockAPI;
